import { IconUsers } from '@tabler/icons-react';
import styled, { useTheme } from 'styled-components';
import { AppText, AppTextProps } from 'components/atoms/CommonAppComponents';

type GroupMailThreadMessageReadStatusCountProps = Pick<AppTextProps, 'textType'> & {
    readStatusCountText: string;
    color?: string;
    className?: string;
    isIconVisible?: boolean;
    onClick?: () => void;
    accessibilityLabel?: string;
};

const Container = styled.div`
    display: flex;
    align-items: center;
`;

export const GroupMailThreadMessageReadStatusCount = ({
    readStatusCountText,
    textType,
    color,
    className,
    isIconVisible = true,
    onClick,
    accessibilityLabel,
}: GroupMailThreadMessageReadStatusCountProps) => {
    const theme = useTheme();

    return (
        <Container className={className} onClick={onClick} aria-label={accessibilityLabel}>
            {isIconVisible && <IconUsers size={20} color={color} />}
            <AppText
                textType={textType}
                margin={0}
                marginLeft={isIconVisible ? theme.sizes.marginSmall : 0}
                color={color}
            >
                {readStatusCountText}
            </AppText>
        </Container>
    );
};
